/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI Calculator (Pixels Per Inch) — Toolverse`)
};

const es_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de PPI (Píxeles por Pulgada) — Toolverse`)
};

const de_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI-Rechner (Pixel pro Zoll) — Toolverse`)
};

const nl_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI Calculator (Pixels Per Inch) — Toolverse`)
};

const fr_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur PPP (Pixels Par Pouce) — Toolverse`)
};

const it_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore PPI (pixel per pollice) — Toolverse`)
};

const pt_br2_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de PPI (Pixels Por Polegada) — Toolverse`)
};

const pt_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de PPI (Pixels por Polegada) — Toolverse`)
};

const ja_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI計算機(1インチあたりのピクセル数) — Toolverse`)
};

const zh_ppi_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI 计算器（每英寸像素数）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_meta_title", locale)
	if (locale === "en") return en_ppi_meta_title(inputs)
	if (locale === "es") return es_ppi_meta_title(inputs)
	if (locale === "de") return de_ppi_meta_title(inputs)
	if (locale === "nl") return nl_ppi_meta_title(inputs)
	if (locale === "fr") return fr_ppi_meta_title(inputs)
	if (locale === "it") return it_ppi_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_meta_title(inputs)
	if (locale === "pt") return pt_ppi_meta_title(inputs)
	if (locale === "ja") return ja_ppi_meta_title(inputs)
	return zh_ppi_meta_title(inputs)
};